module.exports = __webpack_public_path__ + "assets/img/27_1245.6234e8e0.jpg";